// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "footer[data-v-5716519c]{background:#0e1b30;padding:20px 40px 25px;border-top:1px solid #e4e4e4;font-size:12px}.footer-links[data-v-5716519c]{text-align:center}.footer-links a[data-v-5716519c]{color:#fff;padding-right:50px;text-transform:uppercase}.footer-links a[data-v-5716519c]:hover{color:#e6e6e6}\n", ""]);
// Exports
module.exports = exports;
